// useMiPlan.js — Plan de formación del alumno (Learning, config_json.planes_formacion.activo).
// Devuelve { listo, modo, cursos, plan, subrol_label, avance, detalle }:
//   modo 'todos'    → sin subrol o «Sin institución»: ve todo el catálogo (cursos = null);
//   modo 'plan'     → subrol especial: solo `cursos` (ids de documento), en «Mis cursos obligatorios»;
//   modo 'inactivo' → no ve cursos.
// En proyectos sin planes o para el personal, { listo: true, modo: null } y nada cambia.
// Una sola consulta por sesión de página (se comparte entre la portada, Progreso y el buscador);
// con `detalle` trae además el avance por curso (página Mi plan de formación).
import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProject } from '../contexts/ProjectContext';
import { miPlanService } from '../services/api';

const cache = {};   // { 'uid:detalle': promesa }

export const planesActivos = (proyecto) => !!proyecto?.config_json?.planes_formacion?.activo;

const useMiPlan = ({ detalle = false } = {}) => {
  const { user } = useAuth();
  const { proyecto, loading } = useProject();
  const aplica = !!user && planesActivos(proyecto) && !['admin', 'mentor', 'coordinador'].includes(user.role);
  const clave = `${user?.id || 0}:${detalle ? 1 : 0}`;
  const [datos, setDatos] = useState(null);

  useEffect(() => {
    if (!aplica) { setDatos(null); return undefined; }
    let vivo = true;
    if (!cache[clave]) cache[clave] = miPlanService.get(detalle).then(r => r.data).catch(() => { delete cache[clave]; return null; });
    cache[clave].then(d => { if (vivo) setDatos(d || { modo: 'todos', cursos: null }); });
    return () => { vivo = false; };
  }, [aplica, clave, detalle]);

  // Mientras carga el proyecto no se sabe si aplica (una página no debe decidir antes).
  if (loading || (user && !proyecto)) return { listo: false, modo: null, cursos: null };
  if (!aplica) return { listo: true, modo: null, cursos: null };
  if (!datos) return { listo: false, modo: null, cursos: null };
  return { listo: true, ...datos };
};

// Para refrescar el avance tras completar algo (el siguiente uso vuelve a consultar).
export const olvidarMiPlan = () => { Object.keys(cache).forEach(k => delete cache[k]); };

export default useMiPlan;
